module.exports = "pegasus/assets/theme4/main-bg.jpg";